import { useState } from "react";
import { useDebounce } from "./useDebounce";

export interface HandleInputChangeEvent {
  target?: {
    value?: string;
  };
}

function useInputDebounce() {
  const [inputValue, setInputValue] = useState("");
  const { debouncedValue, isSearching } = useDebounce(inputValue, 500);

  const handleInputChange = (e: HandleInputChangeEvent | string) => {
    setInputValue(
      (e as HandleInputChangeEvent)?.target?.value ?? (e as string) ?? ""
    );
  };

  return {
    inputValue,
    debouncedValue,
    isSearching,
    handleInputChange,
  };
}

export default useInputDebounce;
